import React from 'react';

import {VersionsMenuButton} from 'app/components/general/DetailPage/LeftSidebar/VersionsSidebar/MenuButton/BaseVersionsMenuButton';
import {useProcessVersions} from 'app/process/api';

import type {LeftSidebarMenuButton} from 'app/components/general/DetailPage/LeftSidebar/structure/types';
import type {ProcessHashidSerializedType} from 'sweet-types';

export const ProcessVersionsMenuButton = ({
  object,
  forceTooltipShow,
  hideTooltip,
  location,
  params,
  active,
}: LeftSidebarMenuButton<ProcessHashidSerializedType>) => {
  const {data: versions} = useProcessVersions({objectId: object.id});

  if (versions == null) {
    return null;
  }

  return (
    <VersionsMenuButton
      object={object}
      forceTooltipShow={forceTooltipShow}
      hideTooltip={hideTooltip}
      versions={versions.results}
      location={location}
      params={params}
      active={active}
    />
  );
};
